import Image from 'next/image'

import FavoriteButton from '@components/FavoriteButton'
import { slugify } from '@lib/hooks/use-slugify'
import LocalizedClientLink from '@modules/common/components/localized-client-link'

import UndefinedImage from '../../public/undefined-destination.webp'
import { useParams } from 'next/navigation'

export default function BubbleCard({ bubble, user_token = '', clickAction }) {
  const { countryCode } = useParams()

  return (
    <div className="relative">
      <div
        className="relative cursor-pointer isolate flex h-[275px] w-full flex-col justify-between gap-3 overflow-hidden rounded p-4 shadow-lg transition hover:scale-[1.02]"
        onClick={clickAction}
      >
        <div className="absolute inset-0 -z-10 overflow-hidden">
          <Image
            src={
              (bubble.metadata?.thumbnail_url as string) ?? UndefinedImage
            }
            alt={bubble.name || 'Bulle verte'}
            className="h-full w-full object-cover"
            width={400}
            height={400}
          />
          <div className="bg-gradient-overlay-2 absolute inset-0 z-[49]" />
        </div>

        <div>
          <h2
            className={
              'mb-1 line-clamp-2 font-playfairDisplay-bold-italic text-[22px] font-normal leading-tight text-white'
            }
          >
            {bubble.name} 
          </h2>
        </div>
      </div>

      {/* Heart icon always in bottom right */}
      <div className="absolute bottom-4 right-4">
        <FavoriteButton
          className="flex w-fit rounded-full border-2 border-white bg-black/20 backdrop-blur-sm"
          documentId={bubble.metadata.strapi_document_id}
          medusaId={bubble?.id}
          documentType="bubble"
          authenticated={!!user_token}
          clickable={true}
        />
      </div>
    </div>
  )
}


